import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Gift } from "@phosphor-icons/react";
import { Logo } from "../components/Logo";
import { ProfessionPicker } from "../components/ProfessionPicker";
import { getProfession } from "../lib/professions";
import { GoogleButton } from "../components/GoogleAuth";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const refCode = params.get("ref") || "";
  const [form, setForm] = useState({ name: "", email: "", password: "", clinic_name: "", profession: "dentista" });
  const [referrer, setReferrer] = useState(null);
  useEffect(() => { if (refCode) api.get(`/referrals/validate/${refCode}`).then((x) => setReferrer(x.data.referrer_name)).catch(() => setReferrer(false)); }, [refCode]);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register({ ...form, referral_code: refCode || null });
    setLoading(false);
    if (r.ok) {
      toast.success("Conta criada!");
      navigate("/app");
    } else {
      toast.error(r.error);
    }
  };

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md card-crisp p-8">
        <div className="mb-6"><Logo size={44} tagline /></div>
        <h1 className="font-heading text-2xl font-extrabold mb-1">Criar conta</h1>
        <p className="text-sm text-slate-600 mb-6">Comece agora. Grátis para testar.</p>

        {refCode && referrer !== false && (
          <div className="mb-5 flex items-start gap-2 rounded-md bg-emerald-50 border border-emerald-200 p-3 text-sm text-emerald-800" data-testid="register-referral-banner">
            <Gift size={18} weight="duotone" className="shrink-0 mt-0.5" />
            <span>{referrer ? <><strong>{referrer}</strong> indicou você! </> : "Você foi indicado(a)! "}Ao assinar um plano, vocês dois ganham <strong>1 mês grátis</strong>.</span>
          </div>
        )}
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Nome completo</Label>
            <Input value={form.name} onChange={update("name")} required data-testid="reg-name" className="mt-1" />
          </div>
          <div>
            <Label>Qual é a sua área?</Label>
            <p className="text-xs text-slate-500 mb-2">O sistema se adapta ao seu tipo de atendimento.</p>
            <ProfessionPicker value={form.profession} onChange={(profession) => setForm({ ...form, profession })} />
          </div>
          <div>
            <Label>Nome {getProfession(form.profession).de} {getProfession(form.profession).place}</Label>
            <Input value={form.clinic_name} onChange={update("clinic_name")} data-testid="reg-clinic" className="mt-1" />
          </div>
          <div>
            <Label>E-mail</Label>
            <Input type="email" value={form.email} onChange={update("email")} required data-testid="reg-email" className="mt-1" />
          </div>
          <div>
            <Label>Senha</Label>
            <Input type="password" value={form.password} onChange={update("password")} required minLength={6} data-testid="reg-password" className="mt-1" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700" data-testid="reg-submit">
            {loading ? "Criando..." : "Criar conta"}
          </Button>
        </form>

        <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><span className="flex-1 h-px bg-slate-200" />ou<span className="flex-1 h-px bg-slate-200" /></div>
        <GoogleButton profession={form.profession} label="Criar conta com Google" />

        <p className="mt-6 text-sm text-slate-600">
          Já tem conta?{" "}
          <Link to="/login" className="text-indigo-600 font-medium hover:underline" data-testid="link-login">Entrar</Link>
        </p>
      </div>
    </div>
  );
}
